export default {
  size: 'small',
  labelWidth: '90px'
}